import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-grade-icon",
  viewBox: "0 0 11 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.22704 9H1.5V6.27296C1.5 5.99351 1.61073 5.7246 1.80898 5.5274L6.02714 1.30924C6.43946 0.896919 7.10699 0.896919 7.51826 1.30924L9.19076 2.98174C9.60308 3.39407 9.60308 4.06159 9.19076 4.47286L4.9726 8.69102C4.7754 8.88822 4.50649 9 4.22704 9V9Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }